var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"open":_vm.open,"close-modal":_vm.closeModal}},[_c('h2',{staticClass:"modal__header"},[_vm._v("Edit Note")]),_c('NoteForm',{attrs:{"form-values":_vm.formValues,"on-submit":_vm.editNote}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }